import React from 'react';
import { IAvailableTime, IVessel } from "../../../../../util/varibles/interface";
import AvailableTime from "./AvailableTime";

interface IProps {
    available_times: IAvailableTime[]
    vesselIndex: number
    width: number
    vessel: IVessel
}

const AvailableTimes: React.FC<IProps> = ({
    vesselIndex,
    width,
    vessel,
    available_times,
}) => {
    return <>
        {available_times.map((sub, index) => <AvailableTime key={sub.id} {...{
            index,
            data: sub,
            vessel,
            width,
            vesselIndex,
        }} />)}
    </>
};

export default AvailableTimes;